import React, { ButtonHTMLAttributes, PropsWithChildren } from 'react';

import LoadingSpinner from 'components/loading-spinner';
import { Button } from './components';

type ButtonPrimaryProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'disabled'
> & {
  backgroundColor?: string;
  disabled?: boolean;
  isLoading?: boolean;
  'aria-label'?: string;
  'aria-describedby'?: string;
};

const ButtonPrimary = ({
  backgroundColor,
  disabled,
  isLoading,
  children,
  'aria-label': ariaLabel,
  'aria-describedby': ariaDescribedBy,
  ...props
}: PropsWithChildren<ButtonPrimaryProps>) => {
  const computedAriaLabel = isLoading
    ? `${ariaLabel || children} (Loading...)`
    : ariaLabel;

  return (
    <Button
      backgroundColor={backgroundColor}
      disabled={disabled || isLoading}
      aria-label={computedAriaLabel}
      aria-describedby={ariaDescribedBy}
      aria-busy={isLoading}
      {...props}>
      {children}
      {isLoading && <LoadingSpinner size={24} marginLeft={10} />}
    </Button>
  );
};

export default ButtonPrimary;
